module.exports = __webpack_public_path__ + "logo_fispal_food.png?37f853559f4cb003a7a1ad03c4b2da7b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_fispal_food.png
// module id = 180
// module chunks = 0